
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util';
import header1 from '@/components/headers/front-end-header.vue'
import footer1 from '@/components/footers/footer.vue'
import common from '@/lib/common';
import appConst from '@/lib/appConst';
import ProductCategory from '@/store/entities/baseInfo/ProductCategory';
import ProductFinding from '@/store/entities/baseInfo/ProductFinding';
import PageRequest from '@/store/entities/page-request';
import Breadcrumb from './breadcrumb.vue';
import ProductFindingReply from '@/store/entities/baseInfo/ProductFindingReply';

class PageProductRequest extends PageRequest{
  keyword: string;
  tenantId: number;
  from: Date;
  to: Date;
  productFindingId: number;
}

@Component({
  components:{ header1, footer1, Breadcrumb }
})
export default class SearchByImage extends AbpBase {
  uploadedFileName: String = '';
  uploadingHeaders: any = { TenantId: 2 };
  pagerequest: PageProductRequest = new PageProductRequest();
  parentCategory: ProductCategory = null;
  productFindingId: number;
  saveLoading: boolean = false;
  productFindingReply: ProductFindingReply = new ProductFindingReply();
  productFindingReplyRule={
    content: [{required: true, message: this.L('FieldIsRequired', undefined, this.L('Content')), trigger: 'blur'}],
  }

  get currentPath () {
    return this.$store.state.app.currentPath;
  }
  get productFinding(){
    return this.$store.state.productFinding.editProductFinding;
  }
  get list(){
    return this.$store.state.productFindingReply.list;
  }
  get pageSize(){
    return this.$store.state.productFindingReply.pageSize;
  }
  get totalCount(){
    return this.$store.state.productFindingReply.totalCount;
  }
  get currentPage(){
    return this.$store.state.productFindingReply.currentPage;
  }

  created(){
    this.$store.commit('productFindingReply/setPageSize', 3);
    this.getProductFinding();
    this.getpage();
  }

  @Watch('$route')
  routeChange(to: any){
    this.getpage();
  }

  pageChange(page: number){
    this.$store.commit('productFindingReply/setCurrentPage', page);
    this.getpage();
  }

  async getProductFinding(){
    if(!this.$route.query.id){
      this.$Modal.warning({
        title:this.L('Tips'),
        content: this.L('NoDataFound'),
        onOk: () => {
          history.go(-1);
        }
      });
    }
    
    this.productFindingId = parseInt(this.$route.query.id.toString());

    await this.$store.dispatch({
        type:'productFinding/get',
        data:{
          id: this.$route.query.id
        },
    });
  }

  async getpage(){
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.productFindingId = this.productFindingId;

    await this.$store.dispatch({
        type:'productFindingReply/getList',
        data:this.pagerequest,
    });
  }

  handleReplyInputFocus(){
    this.$store.dispatch({
      type:'userProfile/getByUserNo',
      data: Util.abp.session.getUserNoCookie()
    }).then((data)=>{
      let userProfile = Util.extend(true, {}, data);
    });
  }

  saveReply(){
    (this.$refs.productFindingReplyForm as any).validate(async (valid: boolean) => {
      if(valid){
        this.saveLoading = true;
        this.productFindingReply.productFindingId = this.productFindingId;
        this.productFindingReply.userNo = Util.abp.session.getUserNoCookie();
        this.productFindingReply.userAvatarImageUrl = Util.abp.session.getUserAvatarCookie();
        this.productFindingReply.userFullName = Util.abp.session.getUserFullnameCookie();
        
        await this.$store.dispatch({
          type: 'productFindingReply/create',
          data: this.productFindingReply
        }).then(() => {
          this.$Message.success(this.L('SubmitSucceeded'));
          this.productFindingReply.content = null;
          this.saveLoading = false;
        }).catch((err) => {
          console.log('err!');
          this.saveLoading = false;
        });
      }
    })
  }

}
